import type { propsInterface } from '~~/modules/design-system/sections/s-markdown.vue'
import type { schemaType as campaignSchemaType } from '~~/shared/api/strapi/campaign/detail/schema'
import type { schemaType as howPlatformWorksPageSchemaType } from '~~/shared/api/strapi/how-platform-works-page/schema'
import type { schemaType as legalInfoPageSchemaType } from '~~/shared/api/strapi/legal-info-page/schema'
import type { schemaType as privacyPolicyPageSchemaType } from '~~/shared/api/strapi/privacy-policy-page/schema'
import type { schemaType as accessibilityPageSchemaType } from '~~/shared/api/strapi/accessibility-page/schema'

export const useToSMarkdown = () => {
  const fromStrapiCampaignDetail = (
    data: campaignSchemaType,
  ): propsInterface['text'] | undefined => {
    if (data.attributes.text) {
      const markdown = data.attributes.text

      return markdown
    }
    return undefined
  }

  const fromStrapiHowPlatformWorksPage = (
    data: howPlatformWorksPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  const fromStrapiLegalInfoPage = (
    data: legalInfoPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  const fromStrapiPrivacyPolicyPage = (
    data: privacyPolicyPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  const fromStrapiAccessibilityPage = (
    data: accessibilityPageSchemaType,
  ): propsInterface['text'] => {
    const markdown = data.attributes.content

    return markdown
  }

  return {
    fromStrapiCampaignDetail,
    fromStrapiHowPlatformWorksPage,
    fromStrapiLegalInfoPage,
    fromStrapiPrivacyPolicyPage,
    fromStrapiAccessibilityPage,
  }
}
